import {
  faKey,
  faHighlighter,
  faGraduationCap,
  faFaceGrinBeamSweat,
} from '@fortawesome/free-solid-svg-icons';

export const summary = [
  {
    id: 1,
    icon: faKey,
    title: 'Key Skills',
    items: [
      'Full-stack development (ASP.NET, .NET Core, C#, React JS, JavaScript, TypeScript)',
      'Cloud platforms (Azure, AWS)',
      'Database management (MS SQL Server), MongoDB',
      'CI/CD and DevOps practices',
    ],
  },
  {
    id: 2,
    icon: faHighlighter,
    title: 'Highlights',
    items: [
      'Currently a Full-Stack Software Developer at ESPC (UK), building Spark, the next-generation estate agent platform that replaces the legacy property marketing systems.',
      'Working across C#/.NET Core microservices, PostgreSQL, RabbitMQ, an API gateway, Kubernetes and AI integrations.',
      'Experience in systems engineering, ETL processes, DevOps and .NET Development',
      "Awarded for performance and innovation, including recognition at Computershare's Global AI Hackathon",
    ],
  },
  {
    id: 3,
    icon: faGraduationCap,
    title: 'Education',
    items: [
      'MSc in Business Information Management (Distinction) from Heriot-Watt University',
      'BEng in Financial and Management Engineering, 5 year integrated masters programme from the University of the Aegean',
      'PeopleCert Education bootcamp, 500 hours of software development training with Software Developer Skills Foundation and Advanced C# certifications',
    ],
  },
  {
    id: 4,
    icon: faFaceGrinBeamSweat,
    title: 'Interests',
    display: 'tags',
    items: [
      '3D printing',
      'Drones',
      'Tennis',
      'Video games',
      'AI agents',
      'Home Assistant (HAOS)',
      'Self-hosting',
      'Coding challenges, currently top 2% on CodeWars',
    ],
  },
];
